export type UsuarioAuditoria = { id: string; nome: string };

export function fmtRegistroData(iso?: string) {
  if (!iso) return '—';
  return new Date(iso).toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: '2-digit',
  });
}

/** Alteração só conta se a data (dia) for diferente da inclusão */
export function registroFoiAlterado(criadoEm: string, atualizadoEm?: string) {
  if (!atualizadoEm) return false;
  const criado = new Date(criadoEm);
  const alt = new Date(atualizadoEm);
  return (
    criado.getFullYear() !== alt.getFullYear()
    || criado.getMonth() !== alt.getMonth()
    || criado.getDate() !== alt.getDate()
  );
}

export function RegistroMeta({
  criadoEm,
  atualizadoEm,
  atualizadoPor,
}: {
  criadoEm: string;
  atualizadoEm?: string;
  atualizadoPor?: UsuarioAuditoria | null;
}) {
  const alterado = registroFoiAlterado(criadoEm, atualizadoEm);
  const porAlteracao = atualizadoPor?.nome;

  return (
    <div className="ac-resp-registro">
      <span className="ac-resp-registro-line">
        <span className="ac-resp-registro-k">Incl.</span>
        {fmtRegistroData(criadoEm)}
      </span>
      {alterado && (
        <>
          <span className="ac-resp-registro-line">
            <span className="ac-resp-registro-k">Alt.</span>
            {fmtRegistroData(atualizadoEm)}
          </span>
          <span
            className="ac-resp-registro-by"
            title={porAlteracao ? `Alterado por ${porAlteracao}` : 'Autor da alteração não registrado'}
          >
            {porAlteracao ? `por ${porAlteracao}` : '—'}
          </span>
        </>
      )}
    </div>
  );
}
